import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    photoId: PropTypes.number.isRequired,
    isActive: PropTypes.bool.isRequired,
    faceMaskPhotoSelected: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
  },
  getInitialState() {
    return {
      isShaking: false,
    };
  },
  componentDidMount() {
    var delay = Math.random() * 1000;
    setTimeout(
      function() {
        this.setState({
          isShaking: true,
        });
      }.bind(this),
      delay
    );
  },
  handleFaceMaskButton() {
    this.props.faceMaskPhotoSelected(this.props.index, this.props.photoId);
  },
  render() {
    if (this.props.isActive) {
      return (
        <div
          className={
            "delete-photo-button" + (this.state.isShaking ? " shake" : "")
          }
          onClick={this.handleFaceMaskButton}
        >
          <strong>
            <i className="fas fa-user-circle" />
          </strong>
        </div>
      );
    } else {
      return (
        <div
          className={
            "delete-photo-button" + (this.state.isShaking ? " shake" : "")
          }
        />
      );
    }
  },
});
